var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-combobox", {
    staticClass: "form-control form-control-sm",
    class: _vm.childclass,
    attrs: {
      id: "infinite-list",
      items: _vm.items,
      "item-text": _vm.itemText,
      "item-value": _vm.itemValue,
      autofocus: _vm.autofocus,
      "hide-details": "",
      placeholder: _vm.childplaceholder,
      clearable: _vm.clearable,
    },
    on: {
      keydown: function ($event) {
        if (
          !$event.type.indexOf("key") &&
          _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])
        ) {
          return null
        }
        $event.preventDefault()
      },
    },
    model: {
      value: _vm.model,
      callback: function ($$v) {
        _vm.model = $$v
      },
      expression: "model",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }